import { render, staticRenderFns } from "./codeModel.vue?vue&type=template&id=bf5116c4&scoped=true"
import script from "./codeModel.vue?vue&type=script&lang=js"
export * from "./codeModel.vue?vue&type=script&lang=js"
import style0 from "./codeModel.vue?vue&type=style&index=0&id=bf5116c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5116c4",
  null
  
)

export default component.exports